<template>
    <secition-card
        title="지원자"
        v-bind="{
            loading,
        }"
    >
        <statistics-chart-applications
            v-bind="{
                statistics,
                statistics_visit,
                searchDateValue,
            }"
        />
    </secition-card>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES } from "@/assets/variables";

import SecitionCard from "@/components/console/dumb/secition-card.vue";
import StatisticsChartApplications from "@/components/console/statistics/chart/statistics-chart-applications.vue";

export default {
    components: {
        SecitionCard,
        StatisticsChartApplications,
    },
    props: {
        _recruitment: { type: String, default: undefined },
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        statistics: [],
        statistics_visit: [],

        loading: false,
    }),
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { _recruitment, searchDateValue } = this;
                const { statistics } = await api.console.recruitments.applications.gets({
                    _recruitment,
                    headers: { mode: "daily-statistics" },
                    params: {
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                        searchDateValue,
                    },
                });
                this.statistics = statistics;

                if (_recruitment) {
                    const { statistics: statistics_visit } = await api.console.statistics.visits.gets({
                        params: {
                            searchKey: "route",
                            searchValue: `/recruitments/${_recruitment}`,
                            searchDateValue,
                        },
                        headers: { limit: 10, mode: "daily-statistics" },
                    });
                    this.statistics_visit = statistics_visit;
                }
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>
